import {Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy} from '@angular/core';
import {HistoryButtonComponent} from '../history-button/history-button.component';
import {AppQuery} from '../../queries/app.query';
import {HistoryStoreItem} from '../../models/history/history-store-item.model';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
    host: { 'attr.data-qa': 'header-bar' },
    selector: 'app-header',
    imports: [
        HistoryButtonComponent
    ],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header.component.css',
})
export class HeaderComponent {
    public title: InputSignal<string> = input.required();
    public qaTag: InputSignal<string> = input.required();
    public hideHistoryButton: InputSignal<boolean> = input(false);
    public historyBackAction: InputSignal<(() => void) | undefined> = input();
    public hasHistoryCloseButton: InputSignal<boolean> = input(false);
    protected readonly showHistoryButton: Signal<boolean>;
    private readonly historyItems: Signal<Array<HistoryStoreItem>>;
    private readonly appQuery = inject(AppQuery);

    public constructor() {
        this.historyItems = toSignal(this.appQuery.history$, { initialValue: [] });
        this.showHistoryButton = computed(() => this.historyItems().length > 0 && !this.hideHistoryButton());
    }
}
